import { render, staticRenderFns } from "./MsgAnalysisLink.vue?vue&type=template&id=25dd47cc&"
import script from "./MsgAnalysisLink.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysisLink.vue?vue&type=script&lang=js&"
import style0 from "./MsgAnalysisLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports